import { createAxios } from 'giime';

const { service } = createAxios({
  baseURL: import.meta.env.VITE_GASS_API_URL,
  successCode: 0, // 服务器调用成功的code 一般是 0 或 200
  // 是否携带cookie，解决资源与请求同时只携带cookie
  withCredentials: true,
  // 是否隐藏Authorization头
  hideAuthorization: true,
});

// 你也可以再自定义拦截器
// service.interceptors.request.use();
export default service;
